import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";

import AccordianCommon from "../../components/Shared/AccordianCommon";

export default class Questions extends Component {
  render() {
    return (
      <React.Fragment>
        <Container className="mt-100 mt-60">
          <Row className="align-items-center">
            <Col md={6}>
              <div className="section-title text-md-start text-center">
                <h4 className="title mb-4">You have any questions ?</h4>
                <p className="text-muted mb-0 para-desc">
                  Download the{" "}
                  <span className="text fw-bold" style={{color: "#f7961c"}}>
                    Zenstrin
                  </span>{" "}
                  app that can provides everything you need.
                </p>

                {/* <ul className="list-unstyled text-muted mt-4 mb-0">
                  <li className="mb-0">
                    <span className="text-primary h5 me-2">
                      <i className="uil uil-check-circle align-middle"></i>
                    </span>
                    Digital Marketing Solutions for Tomorrow
                  </li>
                  <li className="mb-0">
                    <span className="text-primary h5 me-2">
                      <i className="uil uil-check-circle align-middle"></i>
                    </span>
                    Our Talented & Experienced Marketing Agency
                  </li>
                  <li className="mb-0">
                    <span className="text-primary h5 me-2">
                      <i className="uil uil-check-circle align-middle"></i>
                    </span>
                    Create your own skin to match your brand
                  </li>
                </ul> */}
              </div>
            </Col>

            <Col md={6} className="mt-4 mt-sm-0 pt-2 pt-sm-0">
              <div className="faq-content">
                <div className="accordion" id="accordionExampleone">
                  <AccordianCommon
                    question1="How do I get started?"
                    answer1="You can dowmload the app and create your account."
                    question2="I can't see my property?"
                    answer2="Once a property has been assigned to you it will become visible in the app."
                    question3="Can I have multiple properties?"
                    answer3="Yes you can have multiple properties. You can switch between them in the app."
                    question4="Can I view the tenants in my property?"
                    answer4="Yes you can view the tenants in your property and all their information."
                    question5="Can I view the rental income?"
                    answer5="Yes, you can view the rental income and all the transactions."
                  />
                </div>
              </div>
            </Col>
          </Row>

          <div className="row mt-5 pt-md-4 justify-content-center">
            <div className="col-12 text-center">
              <div className="section-title">
                <h4 className="title mb-4">Have Question ? Get in touch!</h4>
                {/* <p className="text-muted para-desc mx-auto">
                  Start working with{" "}
                  <span className="text-primary fw-bold">
                    Landrick
                  </span>{" "}
                  that can provide everything you need to generate awareness,
                  drive traffic, connect.
                </p> */}
                <Link
                  to="/contact"
                  className="btn btn-pills btn-primary mt-4"
                >
                  <i className="mdi mdi-phone"></i> Contact us
                </Link>
              </div>
            </div>
          </div>
        </Container>
      </React.Fragment>
    );
  }
}
